import Rest from '../Rest'

export default class OrganizationalUnitSponsorService extends Rest {
  /**
   * @type {String}
   */
  static resource = '/api/v1/organizational_unit_sponsors'

  static build(vs: any = null) {
    return new this(this.resource, null, vs)
  }
}
